import { useCallback } from 'react';

import { usePromocodeBatchDeleteMutation } from '@occc/graphql';
import { useMutation } from '@occc-app/dataAccessLayer/utils';

// Delete Promocode inside Promocodes Offer
export const useDeletePromocode = () => {
  const [mutate, { loading }] = useMutation(usePromocodeBatchDeleteMutation, {
    refetchQueries: ['offer'],
  });

  const deletePromocode = useCallback(
    (params: { promocodeId: string }) =>
      mutate({
        variables: {
          ids: [params.promocodeId],
        },
      }),
    [mutate],
  );

  return { delete: deletePromocode, isLoading: loading };
};
